import { nav } from './components/nav';
import { faq } from './components/faq';
import { headings } from './components/headings';
import { animations } from './components/animations';
import { gallery } from './components/gallery';
import { form } from './components/form';

// make $ global
!window.$ && (window.$ = jQuery);

$(() => {
  nav();
  faq();
  headings();
  animations();
  form();
  gallery();
});
